import { ForumQuestionAnswerModal } from "src/components/Main/News/Forum/ForumQuestionAnswerModal";
import { AddFlashcardModal } from "src/components/Modals/AddFlashcardModal";
import { AddFolderContentModal } from "src/components/Modals/AddFolderContentModal";
import { ChangeNameModal } from "src/components/Modals/ChangeNamesModals/ChangeNameModal";
import { ChatbotInstructionsModal } from "src/components/Modals/ChatbotInstructionsModal";
import { DeleteLessonNoteConfirmationModal } from "src/components/Modals/ConfirmationModals/DeleteLessonNoteConfirmationModal";
import { RegenerateDiscussionConfirmationModal } from "src/components/Modals/ConfirmationModals/RegenerateDiscussionConfirmationModal";
import { RegenerateSectionConfirmationModal } from "src/components/Modals/ConfirmationModals/RegenerateSectionConfirmationModal";
import { CreateFolderModal } from "src/components/Modals/CreateFolderModal";
import { DeckPreviewModal } from "src/components/Modals/DeckPreviewModal";
import { DecksImportModal } from "src/components/Modals/DecksImportModal/DecksImportModal";
import { DeleteItemModal } from "src/components/Modals/DeleteModals/DeleteItemModal";
import { EditDeckModal } from "src/components/Modals/EditDeckModal";
import { EditFolderModal } from "src/components/Modals/EditFolderModal";
import { ExamSummaryModal } from "src/components/Modals/ExamSummaryModals/ExamSummaryModal";
import { FinishExamModal } from "src/components/Modals/FinishExamModals/FinishExamModal";
import { GenerateCourseFromWrongAnswersModal } from "src/components/Modals/GenerateCourseFromWrongAnswersModal";
import { GlobalSearchModal } from "src/components/Modals/GlobalSearchModal";
import { LiveUpdateReadyModal } from "src/components/Modals/LiveUpdateReadyModal";
import { MoveToFolderModal } from "src/components/Modals/MoveToFolderModal";
import { SetAvatarModal } from "src/components/Modals/ProfilModals/SetAvatarModal";
import { QuestionViewModal } from "src/components/Modals/QuestionViewModal";
import { ReportCourseReservationsModal } from "src/components/Modals/ReportsModals/ReportCourseReservationsModal";
import { RestoreDeckDraftModal } from "src/components/Modals/RestoreDeckDraftModal";
import { SelectFoldersModal } from "src/components/Modals/SelectFoldersModal";
import { DeckStatisticsModal } from "src/components/Modals/StatisticsModals/DeckStatisticsModal";
import { ExamStatisticsModal } from "src/components/Modals/StatisticsModals/ExamStatisticsModal";
import { ExamsStatisticsModal } from "src/components/Modals/StatisticsModals/ExamsStatisticsModal";
import { KnowDontKnowDeckStatisticsModal } from "src/components/Modals/StatisticsModals/KnowDontKnowDeckStatisticsModal";
import { SpacedRepetitionDeckStatisticsModal } from "src/components/Modals/StatisticsModals/SpacedRepetitionDeckStatisticsModal";
import { UploadModal } from "src/components/Modals/UploadModal";

export const modals = {
	DeleteItemModal: DeleteItemModal,
	AddFolderContentModal: AddFolderContentModal,
	CreateFolderModal: CreateFolderModal,
	EditFolderModal: EditFolderModal,
	ForumQuestionAnswerModal: ForumQuestionAnswerModal,
	QuestionViewModal: QuestionViewModal,
	ExamStatisticsModal: ExamStatisticsModal,
	FinishExamModal: FinishExamModal,
	ExamSummaryModal: ExamSummaryModal,
	ChangeNameModal: ChangeNameModal,
	DeckPreviewModal: DeckPreviewModal,
	EditDeckModal: EditDeckModal,
	RegenerateSectionConfirmationModal: RegenerateSectionConfirmationModal,
	RegenerateDiscussionConfirmationModal: RegenerateDiscussionConfirmationModal,
	DeleteLessonNoteConfirmationModal: DeleteLessonNoteConfirmationModal,
	ReportCourseReservationsModal: ReportCourseReservationsModal,
	ExamsStatisticsModal: ExamsStatisticsModal,
	GenerateCourseFromWrongAnswersModal: GenerateCourseFromWrongAnswersModal,
	SetAvatarModal: SetAvatarModal,
	MoveToFolderModal: MoveToFolderModal,
	SelectFoldersModal: SelectFoldersModal,
	UploadModal: UploadModal,
	DecksImportModal: DecksImportModal,
	KnowDontKnowDeckStatisticsModal: KnowDontKnowDeckStatisticsModal,
	SpacedRepetitionDeckStatisticsModal: SpacedRepetitionDeckStatisticsModal,
	DeckStatisticsModal: DeckStatisticsModal,
	AddFlashcardModal: AddFlashcardModal,
	RestoreDeckDraftModal: RestoreDeckDraftModal,
	ChatbotInstructionsModal: ChatbotInstructionsModal,
	GlobalSearchModal: GlobalSearchModal,
	LiveUpdateReadyModal: LiveUpdateReadyModal,
};

export const ModalsNames = {
	DeleteItemModal: "DeleteItemModal",
	AddFolderContentModal: "AddFolderContentModal",
	CreateFolderModal: "CreateFolderModal",
	EditFolderModal: "EditFolderModal",
	ForumQuestionAnswerModal: "ForumQuestionAnswerModal",
	QuestionViewModal: "QuestionViewModal",
	ExamStatisticsModal: "ExamStatisticsModal",
	FinishExamModal: "FinishExamModal",
	ExamSummaryModal: "ExamSummaryModal",
	ChangeNameModal: "ChangeNameModal",
	DeckPreviewModal: "DeckPreviewModal",
	EditDeckModal: "EditDeckModal",
	RegenerateSectionConfirmationModal: "RegenerateSectionConfirmationModal",
	RegenerateDiscussionConfirmationModal:
		"RegenerateDiscussionConfirmationModal",
	DeleteLessonNoteConfirmationModal: "DeleteLessonNoteConfirmationModal",
	ReportCourseReservationsModal: "ReportCourseReservationsModal",
	ExamsStatisticsModal: "ExamsStatisticsModal",
	GenerateCourseFromWrongAnswersModal: "GenerateCourseFromWrongAnswersModal",
	SetAvatarModal: "SetAvatarModal",
	MoveToFolderModal: "MoveToFolderModal",
	SelectFoldersModal: "SelectFoldersModal",
	UploadModal: "UploadModal",
	DecksImportModal: "DecksImportModal",
	KnowDontKnowDeckStatisticsModal: "KnowDontKnowDeckStatisticsModal",
	SpacedRepetitionDeckStatisticsModal: "SpacedRepetitionDeckStatisticsModal",
	DeckStatisticsModal: "DeckStatisticsModal",
	AddFlashcardModal: "AddFlashcardModal",
	RestoreDeckDraftModal: "RestoreDeckDraftModal",
	ChatbotInstructionsModal: "ChatbotInstructionsModal",
	GlobalSearchModal: "GlobalSearchModal",
	LiveUpdateReadyModal: "LiveUpdateReadyModal",
};
